import React, { useEffect, useState } from "react";
import LayoutV2 from "containers/LayoutV2";
import UserApi from "service/userApi";
import CauHinhThongKeKhachHangApi from "service/CauHinhThongKeKhachHangApi";
import DANH_SACH_TAB from "./danhSachTab";
import MenuChucNang from "./MenuChucNang";
import DanhSachThuocTinhTable from "./DanhSachThuocTinhTable";
import ThemSuaThuocTinh from "./ChucNang/ThemSuaThuocTinh";
import XoaThuocTinh from "./ChucNang/XoaThuocTinh";
import KhoaThuocTinh from "./ChucNang/KhoaThuocTinh";
import "../../../assets/css/table-kydonglai.css";

const CauHinhThongKeKhachHang = () => {
    const [loading, setLoading] = useState(true);
    const [tabIndex, setTabIndex] = useState(0);
    const [dataResponse, setdataResponse] = useState([]);

    const [hasPermission, setHasPermission] = useState(null);
    const [RoleThemMoi, setRoleThemMoi] = useState(null);
    const [RoleSua, setRoleSua] = useState(null);
    const [RoleXoa, setRoleXoa] = useState(null);

    const [showModel, setShowModel] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [showXoa, setShowXoa] = useState(false);
    const [deleteItem, setDeleteItem] = useState(null);
    const [showKhoa, setShowKhoa] = useState(false);
    const [khoaItem, setKhoaItem] = useState(null);

    const tab = DANH_SACH_TAB[tabIndex];

    useEffect(() => {
        document.title =
            "Cấu hình thống kê hợp đồng | Phần mềm quản lý cầm đồ - Morman";
        fetchPermission();
    }, []);

    const fetchPermission = async () => {
        try {
            const res = await UserApi.getAllQuyen();
            const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
            setHasPermission(roles.includes("cauhinhthongkekhachhang"));
            setRoleThemMoi(roles.includes("cauhinhthongkekhachhang_themmoi"));
            setRoleSua(roles.includes("cauhinhthongkekhachhang_sua"));
            setRoleXoa(roles.includes("cauhinhthongkekhachhang_xoa"));
        } catch (err) {
            console.error("Lỗi load quyền:", err);
            setHasPermission(false);
            setRoleThemMoi(false);
            setRoleSua(false);
            setRoleXoa(false);
        }
    };

    const onSearch = async (loai) => {
        try {
            setLoading(true);
            const res = await CauHinhThongKeKhachHangApi.danhSach({ loai });
            setdataResponse(res.data || []);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        } catch (error) {
            console.error("Lỗi load danh sách cấu hình thống kê hợp đồng:", error);
            setdataResponse([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (hasPermission) {
            onSearch(tab.loai);
        }
    }, [hasPermission, tabIndex]);

    const btnChonTabClick = (index) => {
        if (index === tabIndex) return;
        setdataResponse([]);
        setTabIndex(index);
    };

    const btnThemMoiClick = () => {
        setEditingItem({ Id: 0, Ten: "" });
        setShowModel(true);
    };

    const btnSuaClick = (item) => {
        setEditingItem(item);
        setShowModel(true);
    };

    const btnKhoaClick = (item) => {
        setKhoaItem(item);
        setShowKhoa(true);
    };

    const btnXoaClick = (item) => {
        setDeleteItem(item);
        setShowXoa(true);
    };

    if (hasPermission === null) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div className="loader loader-default is-active"></div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }

    if (hasPermission === false) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div
                            className="custom-table-cell text-center red"
                            style={{ width: "100%" }}
                        >
                            Bạn không có quyền truy cập trang này!
                        </div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }

    return (
        <LayoutV2>
            <div id="form-repeater">
                <div className="sticky-moman-bh">
                    <div className="col-12">
                        <div className="camdo-home">
                            <div className="breadcrumb-new">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 title-cd">
                                        <div className="media-home align-center-home">
                                            <div className="row header">
                                                <img
                                                    src="/app-assets/images/icon-cau-hinh-tai-san.png"
                                                    alt="logo"
                                                    style={{ maxWidth: "30px" }}
                                                />
                                                <h1 className="text-info-home">
                                                    Quản trị hệ thống - Cấu hình thống kê hợp đồng
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card border-light mb-3 card-v2">
                                <div
                                    className="card-body card-body-v2"
                                    style={{ userSelect: "text" }}
                                >
                                    <ul className="nav nav-tabs bg-tab">
                                        {DANH_SACH_TAB.map((item, index) => (
                                            <li className="nav-item" key={item.loai}>
                                                <a
                                                    className={
                                                        index === tabIndex
                                                            ? "nav-link active"
                                                            : "nav-link"
                                                    }
                                                    style={{ cursor: "pointer" }}
                                                    title={item.moTa}
                                                    onClick={() => btnChonTabClick(index)}
                                                >
                                                    <h4>{item.tenTab}</h4>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>

                                    <div
                                        className="card-body card-body-v2"
                                        style={{
                                            display: RoleThemMoi ? "block" : "none",
                                            marginTop: "10px",
                                            marginBottom: "10px",
                                            maxHeight: "54px",
                                        }}
                                    >
                                        <MenuChucNang
                                            RoleThemMoi={RoleThemMoi}
                                            btnThemMoiClick={btnThemMoiClick}
                                        />
                                    </div>

                                    {loading && (
                                        <div className="loader loader-default is-active"></div>
                                    )}
                                    {!loading && (
                                        <DanhSachThuocTinhTable
                                            list={dataResponse}
                                            nhanCot={tab.nhanCot}
                                            RoleSua={RoleSua}
                                            RoleXoa={RoleXoa}
                                            btnSuaClick={btnSuaClick}
                                            btnKhoaClick={btnKhoaClick}
                                            btnXoaClick={btnXoaClick}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showModel && (
                    <ThemSuaThuocTinh
                        tab={tab}
                        data={editingItem}
                        onClose={() => setShowModel(false)}
                        onSearch={() => onSearch(tab.loai)}
                    />
                )}

                {showKhoa && (
                    <KhoaThuocTinh
                        tab={tab}
                        data={khoaItem}
                        onClose={() => setShowKhoa(false)}
                        onSearch={() => onSearch(tab.loai)}
                    />
                )}

                {showXoa && (
                    <XoaThuocTinh
                        tab={tab}
                        data={deleteItem}
                        onClose={() => setShowXoa(false)}
                        onSearch={() => onSearch(tab.loai)}
                    />
                )}
            </div>
        </LayoutV2>
    );
};

export default CauHinhThongKeKhachHang;
